var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5dbff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.559,
    x2: 416.559,
    xlinkHref: "#lg1",
    y1: 89.769,
    y2: 675.769
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b799d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3645,
    stopColor: "#096380",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#084f67",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.091,
    x2: 279.591,
    xlinkHref: "#lg2",
    y1: 185.245,
    y2: 18.745
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90217"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 226,
    x2: 308.314,
    xlinkHref: "#lg3",
    y1: 274.107,
    y2: 274.107
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63950",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0467,
    stopColor: "#e4354b",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    stopColor: "#d31822",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7991,
    stopColor: "#c90709",
    stopOpacity: 0.799
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.663,
    x2: 59.663,
    xlinkHref: "#lg4",
    y1: 207.063,
    y2: 64.063
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.643,
    x2: 237.876,
    xlinkHref: "#lg4",
    y1: 158.577,
    y2: 113.809
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.202,
    x2: 268.59,
    xlinkHref: "#lg3",
    y1: 98.771,
    y2: 125.159
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.997,
    x2: 186.33,
    xlinkHref: "#lg4",
    y1: 272.323,
    y2: 293.656
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 450.545,
    y2: 494.293
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485e"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.608,
    x2: 262.487,
    xlinkHref: "#lg5",
    y1: 209.036,
    y2: 379.915
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07485e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232e"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.255,
    x2: 94.255,
    xlinkHref: "#lg6",
    y1: 213.793,
    y2: 248.293
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(-1 0 0 1 -1833.754 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -2252.145,
    x2: -2081.266,
    xlinkHref: "#lg5",
    y1: 209.036,
    y2: 379.915
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.35,
    x2: 43.85,
    xlinkHref: "#lg6",
    y1: 168.892,
    y2: 228.392
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.426,
    x2: 417.093,
    xlinkHref: "#lg2",
    y1: 195.279,
    y2: 273.279
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.158,
    x2: 355.429,
    xlinkHref: "#lg6",
    y1: 386.743,
    y2: 331.014
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.681,
    x2: 435.681,
    xlinkHref: "#lg5",
    y1: 261.709,
    y2: 347.709
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.865,
    x2: 187.731,
    xlinkHref: "#lg6",
    y1: 414.591,
    y2: 355.457
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.999,
    x2: 254.999,
    xlinkHref: "#lg6",
    y1: 432.045,
    y2: 479.64
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.254,
    x2: 169.779,
    xlinkHref: "#lg6",
    y1: 161.708,
    y2: 97.335
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.619,
    x2: 254.619,
    xlinkHref: "#lg6",
    y1: 212.987,
    y2: 94.987
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 39.581,
    y2: 69.991
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.794,
    x2: 329.441,
    xlinkHref: "#lg7",
    y1: 78.759,
    y2: 108.406
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.771,
    x2: 208.771,
    xlinkHref: "#lg7",
    y1: 86.01,
    y2: 110.01
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.247,
    x2: 240.392,
    xlinkHref: "#lg5",
    y1: 235.298,
    y2: 408.442
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.925,
    x2: 251.916,
    xlinkHref: "#lg6",
    y1: 415.954,
    y2: 375.945
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbf00"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.89,
    x2: 256.418,
    xlinkHref: "#lg8",
    y1: 369.993,
    y2: 380.521
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-1 0 0 -1 -2772.562 -4754.28)",
    gradientUnits: "userSpaceOnUse",
    x1: -3028.381,
    x2: -3022.402,
    xlinkHref: "#lg8",
    y1: -5134.203,
    y2: -5128.224
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.835,
    x2: 130.371,
    xlinkHref: "#lg6",
    y1: 356.749,
    y2: 341.285
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.042,
    x2: 132.111,
    xlinkHref: "#lg8",
    y1: 338.985,
    y2: 343.054
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(-1 0 0 -1 -2772.562 -4754.28)",
    gradientUnits: "userSpaceOnUse",
    x1: -2904.441,
    x2: -2902.13,
    xlinkHref: "#lg8",
    y1: -5097.102,
    y2: -5094.792
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.966,
    x2: 150.502,
    xlinkHref: "#lg6",
    y1: 376.88,
    y2: 361.416
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.173,
    x2: 152.242,
    xlinkHref: "#lg8",
    y1: 359.116,
    y2: 363.185
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(-1 0 0 -1 -2772.562 -4754.28)",
    gradientUnits: "userSpaceOnUse",
    x1: -2924.572,
    x2: -2922.262,
    xlinkHref: "#lg8",
    y1: -5117.233,
    y2: -5114.922
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(0 1 1 0 -1557.377 1600.109)",
    gradientUnits: "userSpaceOnUse",
    x1: -1243.331,
    x2: -1258.796,
    xlinkHref: "#lg6",
    y1: 1952.204,
    y2: 1936.74
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientTransform: "matrix(0 1 1 0 -1557.377 1600.109)",
    gradientUnits: "userSpaceOnUse",
    x1: -1261.125,
    x2: -1257.055,
    xlinkHref: "#lg8",
    y1: 1934.44,
    y2: 1938.509
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(0 -1 -1 0 -6311.657 -1172.452)",
    gradientUnits: "userSpaceOnUse",
    x1: -1515.275,
    x2: -1512.964,
    xlinkHref: "#lg8",
    y1: -6692.557,
    y2: -6690.247
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(0 1 1 0 -1597.639 1600.109)",
    gradientUnits: "userSpaceOnUse",
    x1: -1223.2,
    x2: -1238.664,
    xlinkHref: "#lg6",
    y1: 1972.335,
    y2: 1956.871
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(0 1 1 0 -1597.639 1600.109)",
    gradientUnits: "userSpaceOnUse",
    x1: -1240.994,
    x2: -1236.924,
    xlinkHref: "#lg8",
    y1: 1954.57,
    y2: 1958.64
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(0 -1 -1 0 -6351.919 -1172.452)",
    gradientUnits: "userSpaceOnUse",
    x1: -1535.406,
    x2: -1533.095,
    xlinkHref: "#lg8",
    y1: -6712.688,
    y2: -6710.377
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m483.464 130.694-24.76-24.76c-34.856-34.856-82.13-54.437-131.424-54.437h-144.562c-49.294 0-96.568 19.582-131.424 54.437l-24.782 24.782s-13.06 23.701-6.497 30.264l54.348 54.348c6.563 6.563 17.204 6.563 23.767 0l7.601-4.65v244.594c0 9.282 7.524 16.806 16.806 16.806h264.923c9.282 0 16.806-7.524 16.806-16.806v-244.593l7.601 4.65c6.563 6.563 17.204 6.563 23.767 0l54.348-54.348c6.565-6.563-6.518-30.287-6.518-30.287z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.741 142.961-10.277-12.267-24.76-24.76c-28.787-28.787-66.048-47.143-105.919-52.666-5.19-.553-10.414-.915-15.666-1.055-1.76-.05-3.52-.07-5.29-.07h-153.659c-1.77 0-2.549.02-4.309.07-5.13 3.75-8.36 9.79-8.36 16.44v64.26c0 1.67-.341 3.13.689 4.2.822.841 177.163 177.013 238.077 237.967v-37.361l79.307-79.311c31.426-31.427 34.797-80.255 10.167-115.447z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m265.333 124.886h-10.333-10.333l-31.732 237.411c-2.012 15.056 2.896 30.214 13.351 41.233l11.951 12.595c9.112 9.603 24.414 9.603 33.526 0l11.951-12.595c10.455-11.019 15.364-26.177 13.351-41.233z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.504 253.351-17.171-128.465h-10.333-10.333l-10.689 79.972c15.104 15.093 31.666 31.644 48.526 48.493z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.333 124.886h-10.333-10.333l-1.426 10.669 27.147 27.147z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.512 112.997c2.301-9.061-1.597-17.882-10.314-19.84-11.28-2.534-23.115-2.534-34.395 0-8.717 1.958-12.616 10.78-10.314 19.84 1.533 6.035 3.664 11.097 6.246 15.379 2.638 4.376 7.621 7.278 12.516 7.803 5.865.628 11.635.628 17.5 0 4.896-.525 9.878-3.427 12.516-7.803 2.581-4.283 4.712-9.345 6.245-15.379z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.763 416.125 11.951-12.595c10.455-11.019 15.364-26.177 13.351-41.233l-31.732-237.411h-10.333v298.442c6.103 0 12.207-2.401 16.763-7.203z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m105.732 369.488v85.785c0 9.282 7.524 16.806 16.806 16.806h264.923c9.282 0 16.806-7.524 16.806-16.806v-85.785z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.65 387.392c3.663-7.704 3.286-16.72-1.008-24.091l-18.828-32.325c-63.186-112.903-82.954-278.762-82.954-278.762l-.73-.465c-45.801 2.364-89.247 21.597-121.836 54.186l-24.767 24.767s-13.076 23.717-6.513 30.28l54.348 54.348c6.563 6.563 17.204 6.563 23.767 0l7.601-4.65v244.594c0 9.282 7.524 16.806 16.806 16.806h92.906c12.792 0 24.442-7.361 29.935-18.914z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.732 68.205v142.475 126.744h127.323v-285.927h-50.337c-26.82 0-53.036 5.809-76.986 16.708z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.348 387.392c-3.663-7.704-3.286-16.72 1.008-24.091l18.828-32.325c63.186-112.903 82.954-278.762 82.954-278.762l.73-.465c45.801 2.364 89.247 21.597 121.836 54.186l24.727 24.727s13.116 23.757 6.552 30.32l-54.348 54.348c-6.563 6.563-17.204 6.563-23.767 0l-7.601-4.65v244.594c0 9.282-7.524 16.806-16.806 16.806h-92.906c-12.792 0-24.442-7.361-29.935-18.914z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.295 105.934-24.739 24.739s-13.104 23.745-6.541 30.308l54.349 54.349c6.563 6.563 17.204 6.563 23.767 0l7.601-4.65v-142.475c-20.068 9.134-38.546 21.838-54.437 37.729z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.28 51.497h-50.337v285.927h127.323v-126.745-142.474c-23.949-10.899-50.166-16.708-76.986-16.708z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.27 294.965v160.31c0 2.75-.66 5.34-1.84 7.63l-83.05-83.05z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.567 130.801-.128-.128-198.16 198.406c-4.604 4.609-4.601 12.077.005 16.684l47.127 47.127c4.609 4.609 12.081 4.608 16.689 0l134.474-134.481c35.237-35.24 35.234-92.373-.007-127.608z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.721 329.069-63.378 63.378 79.478 79.478 117.323.154z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m122.538 472.079h92.909c12.791-.001 24.44-7.362 29.932-18.914l9.62-20.235 9.62 20.235c5.492 11.552 17.141 18.913 29.932 18.914h92.909c4.641 0 8.842-1.881 11.884-4.922 3.041-3.042 4.922-7.243 4.922-11.884v-85.785h-298.534v85.785c0 2.9.735 5.629 2.028 8.011 2.846 5.239 8.397 8.795 14.778 8.795z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m165.501 68.653v64.26c0 1.67-.341 3.13.689 4.2.208.213 11.669 11.666 29.652 29.637-13.548-54.399-19.927-98.911-21.552-111.178-.291-2.197-8.789 13.081-8.789 13.081z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.574 258.409c31.426-31.427 34.797-80.255 10.167-115.447-.82-2.093-10.296-12.286-10.296-12.286l-24.741-24.741c-32.589-32.589-76.035-51.822-121.836-54.186l-.73.465s-12.548 105.272-49.601 205.169c45.206 45.178 91.869 91.821 117.73 117.698v-37.361z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m317.181 47.136c-40.539-12.287-83.822-12.287-124.361 0-7.217 2.187-10.862 10.173-7.852 17.087 12.05 27.679 38.874 32.309 70.032 32.309 31.159 0 57.983-4.631 70.032-32.309 3.01-6.914-.635-14.9-7.851-17.087z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 96.532c0 1.541.883 2.945 2.272 3.613l79.533 38.23c4.026 1.935 8.691-.999 8.691-5.465v-64.253c0-9.405-6.449-17.583-15.595-19.776l-21.781-4.804c-.868-.191-1.725.342-1.933 1.206-.349 1.457-1.067 3.982-2.515 7.783-7.228 18.979-18.893 37.522-48.672 37.522z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 90.588c-29.779 0-41.444-18.542-48.672-37.522-1.447-3.8-2.166-6.326-2.515-7.783-.207-.864-1.064-1.398-1.933-1.206l-21.78 4.804c-9.146 2.193-15.595 10.371-15.595 19.776v64.253c0 4.467 4.665 7.4 8.691 5.465l79.533-38.23c1.389-.668 2.272-2.072 2.272-3.613v-5.944z",
    fill: "url(#SVGID_22_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m26.561 130.673-.128.128c-35.241 35.236-35.244 92.369-.006 127.608l134.474 134.481c4.608 4.609 12.08 4.609 16.689 0l47.127-47.127c4.606-4.606 4.609-12.074.005-16.684z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m318.059 448.817c-8.782 5.621-20.293 4.373-27.666-3l-53.361-53.361c-4.275-4.048-6.598-9.776-6.598-16.128-.001-12.005 9.862-21.867 21.866-21.866 6.352 0 12.08 2.324 16.128 6.598l53.361 53.361c10.025 10.026 8.211 26.752-3.73 34.396z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 252.223,
    cy: 376.326,
    fill: "url(#SVGID_25_)",
    r: 22.209
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.223,
    cy: 376.326,
    fill: "url(#SVGID_26_)",
    r: 12.612
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m155.936 369.451c-3.394 2.173-7.844 1.69-10.694-1.159l-20.625-20.625c-1.652-1.564-2.55-3.779-2.55-6.234 0-4.64 3.812-8.452 8.452-8.452 2.455 0 4.669.898 6.234 2.55l20.625 20.625c3.875 3.876 3.174 10.341-1.442 13.295z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 130.49,
    cy: 341.432,
    fill: "url(#SVGID_28_)",
    r: 8.584
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.49,
    cy: 341.432,
    fill: "url(#SVGID_29_)",
    r: 4.875
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176.067 389.582c-3.394 2.173-7.844 1.69-10.694-1.159l-20.625-20.625c-1.652-1.564-2.55-3.779-2.55-6.234 0-4.64 3.812-8.452 8.452-8.452 2.455 0 4.669.898 6.234 2.55l20.625 20.625c3.875 3.876 3.174 10.341-1.442 13.295z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 150.621,
    cy: 361.563,
    fill: "url(#SVGID_31_)",
    r: 8.584
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.621,
    cy: 361.563,
    fill: "url(#SVGID_32_)",
    r: 4.875
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m407.529 366.879c2.173-3.395 1.69-7.844-1.16-10.694l-20.625-20.625c-1.564-1.652-3.779-2.55-6.234-2.55-4.64 0-8.452 3.812-8.452 8.452 0 2.455.898 4.669 2.55 6.234l20.625 20.625c3.877 3.875 10.342 3.174 13.296-1.442z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 379.51,
    cy: 341.432,
    fill: "url(#SVGID_34_)",
    r: 8.584
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.51,
    cy: 341.432,
    fill: "url(#SVGID_35_)",
    r: 4.875
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m387.398 387.01c2.173-3.395 1.69-7.844-1.159-10.694l-20.625-20.625c-1.564-1.652-3.779-2.55-6.234-2.55-4.64 0-8.452 3.812-8.452 8.452 0 2.455.898 4.669 2.55 6.234l20.625 20.625c3.876 3.875 10.341 3.174 13.295-1.442z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 359.379,
    cy: 361.563,
    fill: "url(#SVGID_37_)",
    r: 8.584
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.379,
    cy: 361.563,
    fill: "url(#SVGID_38_)",
    r: 4.875
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuit);
export default __webpack_public_path__ + "static/media/icon-suit.dc3e19eda012ebefcee57b1e62d40b4e.svg";
export { ForwardRef as ReactComponent };